import { QuerySwitch } from 'components/QuerySwitch';
import { AvailabilityLocationSettingsPageForm } from 'pages/Settings/pages/LocationSettings/AvailabilityLocationSettingsPageForm';
import {
  LocationRecordDetailDataContext,
  LocationRecordDetailDataProvider,
} from 'pages/Settings/pages/LocationSettings/LocationRecordDetail.data.context';
import { FC } from 'react';

export const AvailabilityLocationSettingsPage: FC = () => {
  return (
    <LocationRecordDetailDataProvider>
      <QuerySwitch
        context={LocationRecordDetailDataContext}
        component={AvailabilityLocationSettingsPageForm}
      />
    </LocationRecordDetailDataProvider>
  );
};
